import { createContext } from "react";

const DF_LO0022Context = createContext();

export { DF_LO0022Context };